module.exports = __webpack_public_path__ + "assets/img/sweep-why.f1a8a50a.png";